import { render, staticRenderFns } from "./SpecialMultiCategory.vue?vue&type=template&id=001e1437&scoped=true"
import script from "./SpecialMultiCategory.vue?vue&type=script&lang=js"
export * from "./SpecialMultiCategory.vue?vue&type=script&lang=js"
import style0 from "./SpecialMultiCategory.vue?vue&type=style&index=0&id=001e1437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e1437",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProduct: require('/home/korzinka/www/front/components/base/Product.vue').default})
